import * as React from 'react';
import { v1 } from 'uuid';

import './ActiveFilters.scss';

interface ActiveFiltersMapProps {
  label: string;
  value: string | number;
  id: string;
}

interface ActiveFiltersProps {
  filters: any;
  handleRemoveFilter: (filter: string) => void;
}

export const ActiveFilters = ({ filters, handleRemoveFilter }: ActiveFiltersProps) => {
  if (filters.length !== 0) {
    return (
      <div className="active-filters__list">
        {filters.map((filter: ActiveFiltersMapProps, index: number) => {
          const handle = () => handleRemoveFilter(filter.id);

          return (
            <div className="active-filters__item" key={`filters-item-${index}-${v1()}`}>
              <div className="active-filters__label">
                <strong>{filter.label}:</strong>
                {filter.value}
              </div>
              <div className="active-filters__remove" onClick={handle}>
                &times;
              </div>
            </div>
          );
        })}
      </div>
    );
  } else {
    return null;
  }
};
